import React from "react";

export default function Car({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={color}
    >
      <g id="car-front" transform="translate(0 0)">
        <g id="Group_332" dataname="Group 332">
          <path
            id="Path_138"
            dataname="Path 138"
            d="M7,21H1v2a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1Z"
            transform="translate(0 -6)"
          />
          <path
            id="Path_139"
            dataname="Path 139"
            d="M23,21H17v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1Z"
            transform="translate(-6 -6)"
          />
          <path
            id="Path_140"
            dataname="Path 140"
            d="M17.341,7.326,16.435,6.5,15.243,1.608A2.2,2.2,0,0,0,13.05,0H4.95A2.2,2.2,0,0,0,2.757,1.608L1.565,6.5l-.906.826A1.952,1.952,0,0,0,0,8.777v3.539A.719.719,0,0,0,.75,13h16.5a.719.719,0,0,0,.75-.684V8.777A1.952,1.952,0,0,0,17.341,7.326ZM4.221,1.9a.733.733,0,0,1,.729-.536h8.1a.734.734,0,0,1,.732.536l1.033,4.254H3.184Zm-.846,9.043A1.079,1.079,0,0,1,2.25,9.921,1.079,1.079,0,0,1,3.375,8.895,1.079,1.079,0,0,1,4.5,9.921,1.079,1.079,0,0,1,3.375,10.947Zm11.25,0A1.079,1.079,0,0,1,13.5,9.921a1.13,1.13,0,0,1,2.25,0A1.079,1.079,0,0,1,14.625,10.947Z"
          />
        </g>
      </g>
    </svg>
  );
}
